/**
 * @param {&} value Any value
 *
 * @returns {true|undefined} True or undefined, used in combination with removeEmptyKeys
 *
 * @example
 * isValueOrUndefined(0); -> true
 * isValueOrUndefined('randomString'); -> true
 * isValueOrUndefined(undefined); -> undefined
 */
const isValueOrUndefined = value => value !== undefined ? true : undefined;
export default isValueOrUndefined;